// ADD YOUR OWN GOOGLE MAPS API KEY HERE
export const API_KEY = 'AIzaSyCpPqjfWIgL56tEjHFAVgka8KCe9vaB6kk'
